// extracted by mini-css-extract-plugin
export default {"root":"sub-header_root__uh4kE","subtitle":"sub-header_subtitle__8Igu2"};